export default __webpack_public_path__ + "static/media/joytcp-4.a5b350c6.png";